module.exports = __webpack_public_path__ + "static/media/blinking.8931471b.JPG";